import { useOnClickOutside } from "@/app/hooks/useOnClickOutside";
import clsx from "clsx";
import { ArrowDown, ChevronDown } from "lucide-react";
import { useState } from "react";

type Props = {
  value: number;
  index: number;
  onAgeChange: (age: number) => void;
  ageOptions: number[];
};

export const CounterAge = ({
  value,
  index,
  ageOptions,
  onAgeChange,
}: Props) => {
  const [isOpen, setOpen] = useState(false);
  const ref = useOnClickOutside<HTMLUListElement>(() => setOpen(false));

  return (
    <div className="relative py-2 px-4">
      <label
        htmlFor=""
        className="flex justify-between items-center font-medium"
        onClick={() => setOpen(true)}
      >
        Child {index + 1}
        <div className="relative max-w-32 w-full border border-sleap-gray-400 rounded-lg">
          <input
            value={value}
            name="age"
            className="py-2 px-4 bg-lightwhite rounded-lg font-medium w-full md:px-2 md:py-1 md:border-none font-inter flex gap-1 text-sleap-gray-700 dark:text-white dark:bg-sleap-gray-950"
            readOnly
          />
          <ChevronDown className="absolute top-1/2 right-3 -translate-y-1/2" />
        </div>
      </label>
      {isOpen && (
        // <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 z-20 md:absolute md:top-full md:left-0">
        <div className="absolute top-3 max-h-60 overflow-y-auto rounded-2xl md:absolute md:top-10  md:right-0 z-20">
          <ul
            className="bg-lightwhite shadow-[0_-20px_25px_-5px_rgba(0,0,0,0.1)] w-56 p-2 dark:bg-sleap-gray-950"
            ref={ref}
          >
            {/* <ul
            className="bg-lightwhite rounded-2xl shadow-[0_-20px_25px_-5px_rgba(0,0,0,0.1)] w-full"
            ref={ref}
          > */}
            {ageOptions.map((age) => (
              <li key={age}>
                <button
                  type="button"
                  className={clsx(
                    "py-2.5 px-3.5 text-base font-medium font-inter text-sleap-gray-700 hover:bg-sleap-flight-blue-50 w-full rounded-none dark:text-lightwhite dark:hover:bg-sleap-fern-100",
                    value === age &&
                      "bg-sleap-flight-blue-50 dark:bg-sleap-fern-100 dark:text-lightwhite"
                  )}
                  onClick={() => {
                    onAgeChange(age);
                    setOpen(false);
                  }}
                >
                  {age}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
